import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { invoiceInvoiceActions } from "../../../../store/external/invoice/invoice.reducer";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { DetailsDashboard } from "../../../common/details-dashboard/details-dashboard-layout";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { TABLE_PAGINATION_KEY, DASHBOARD_LABEL } from "../../../../constants/external-constants";
import './invoice.css';
import InvoiceFormContainer from "./invoice-form/invoice-form.container";
import InvoiceDetailsView from "./invoice-form/invoice-form-view.container";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";


class Invoice extends Component {
    constructor(props){
        super(props);
        this.DisplaySearhBox = this.DisplaySearhBox.bind(this)
        this.state = {
            viewDetailPage: false,
            createNew: false,
            exportAlertMsg: "Please confirm that the harvesting of data and it's usage has been approved by the client.",
            displaySearch: false,
            headerTitle: "invoice_management",
            statusActiveFilter: 0,
            invoiceDetailsId: 0,
            invoiceNumber: 0
        }

    }

    componentDidMount() {
        this.changeHeaderTitle();
        this.props.applyAllInvoiceStatusFilter(0);
        this.props.getAllInvoice();
    }

    componentWillUnmount() {
        this.props.setDefaultAllInvoice();
    }

    DisplaySearhBox() {
        this.setState({ displaySearch: !this.state.displaySearch })
    }

    handleCreateNewAction = () => {
        this.setState({
            showModal: true,
        })
    }

    handleCreateNew(buttonType) {
        if (buttonType === "ok") {
            this.setState({
                createNew: !this.state.createNew,
                showModal: false
            }, this.changeHeaderTitle);
        } else {
            this.setState({ showModal: false })
        }

    }
    resizePage = (value) => {
        const { getAllInvoice, resizeAllInvoicePage } = this.props;
        resizeAllInvoicePage(value);
        getAllInvoice();
    }

    changeHeaderTitle() {
        if (this.state.viewDetailPage || this.state.createNew) {
            this.setState({ headerTitle: "invoice_details_view" })
        } else {
            this.setState({ headerTitle: "invoice_management" })
        }
    }

    onClickExtract = (e) => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractAllInvoice();
        }
    };

    applyFilter = (isApply) => {
        const { getAllInvoice, applyAllInvoiceFilter } = this.props;
        applyAllInvoiceFilter(isApply);
        getAllInvoice(0);
    }

    handleCloseDetailsPage = () => {
        this.setState({
            viewDetailPage: false,
            headerTitle: "invoice_management",
            invoiceDetailsId: 0,
            invoiceNumber: 0
        });
        this.props.getAllInvoice();
    }

    viewDetails(isNew, item) {
        if (!isNew) {
            this.setState({
                headerTitle: "invoice_details_view",
                viewDetailPage: true,
                invoiceDetailsId: item.InvoiceId,
                invoiceNumber: item.InvoiceNum
            });
        }
    }

    statusActiveFilter = (statusActiveFilter) => {
        const { getAllInvoice, applyAllInvoiceStatusFilter } = this.props;
        applyAllInvoiceStatusFilter(statusActiveFilter);  
        getAllInvoice(0);
    }

    loading = () => {
        return (
            <NoSubscription />
        );
    }
    render(){
        const { invoiceInvoice, getAllInvoice, sortAllInvoiceItems, setAllInvoiceColSearchStr, addAllInvoiceFilter, removeAllInvoiceFilter, saveAllInvoiceCustomCols } = this.props;
        const { Selected, Available, Default } = this.props.invoiceInvoice.allInvoiceItems.Columns;
        const { FirstFilter, SecondFilter, ThirdFilter, FourthFilter, TotalFilter } = this.props?.invoiceInvoice?.allInvoiceItems.StatusFilter || {};
        const statusData = [
            { "label": DASHBOARD_LABEL.total, "value": TotalFilter ?? 0},
            { "label": DASHBOARD_LABEL.pending, "value": FirstFilter ?? 0},
            { "label": DASHBOARD_LABEL.approved, "value": SecondFilter ?? 0},
            { "label": DASHBOARD_LABEL.paid, "value": ThirdFilter ?? 0},
            { "label": DASHBOARD_LABEL.rejected, "value": FourthFilter ?? 0}
        ];
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceInvoiceDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceInvoiceDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceInvoiceDashboardRW])

        const roles = {
            isReadOnly,
            isReadAndWrite,
            isReadAndExtractOnly
        }

        return(
            <div className="invoice-wrapper-container inventory-report-component" >
                <RequestHeaders headerTitle={this.state.headerTitle} />                
                <div className="request-table data-table fit-width">
                    {
                         this.state.viewDetailPage ?
                            <InvoiceDetailsView
                                handleClose={this.handleCloseDetailsPage}
                                invoiceDetailsId={this.state.invoiceDetailsId}
                                invoiceNumber={this.state.invoiceNumber}
                                roles={roles}
                            />
                        :
                        <>  
                             <DetailsDashboard 
                                // Filter Properties
                                data={invoiceInvoice.allInvoiceItems.TableFilterData} 
                                translation={""} 
                                addAction={addAllInvoiceFilter} 
                                removeAction={removeAllInvoiceFilter} 
                                applyAction={this.applyFilter}

                                //CreateNew Action
                                createNewAction={this.handleCreateNewAction}
                                isCreateButtonHidden = {true}
                                //View Search Textbox
                                viewSearchAction={this.DisplaySearhBox}

                                //Customize Column
                                firstList={Available} 
                                secondList={Selected} 
                                defaultList={Default} 
                                saveAction={saveAllInvoiceCustomCols}

                                //Extract Button
                                extractAction={(e) => this.onClickExtract(e)}

                                //StatusBar
                                statusData={statusData}
                                activeStatusFilter={this.statusActiveFilter}

                                //Access Type
                                isReadOnly={isReadOnly}
                                isReadAndExtractOnly={isReadAndExtractOnly}
                                isReadAndWrite={isReadAndWrite}
                                >
                         {this.props.invoiceInvoice.isAllInvoiceLoaded ?
                                <TablePagination
                                    key={TABLE_PAGINATION_KEY.invoiceInvoice}  
                                    classNameWrapper="overflow-auto" 
                                    columns={invoiceInvoice.allInvoiceItems.Headers}
                                    pageList={invoiceInvoice.allInvoiceItems.Data}
                                    pages={invoiceInvoice.allInvoiceItems.Pagination}
                                    rowClickAction={(item) => { this.viewDetails(false, item) }}
                                    paginationAction={getAllInvoice}
                                    onColumnClick={sortAllInvoiceItems}
                                    onColumnSearch={() => { getAllInvoice(0) }}
                                    onColumnSearchChange={setAllInvoiceColSearchStr}
                                    isColSearchShow={this.state.displaySearch}
                                    resizePage={this.resizePage}
                                    totalPage={invoiceInvoice.allInvoiceItems.Pagination.TotalEntries}
                                        />
                         : this.loading()}
                            </DetailsDashboard>
                        </>
                    }
                   
                </div>                
            </div>
        )
    }
}

export default connect(
    state => {
        const { invoiceInvoice } = state;

        return {
            invoiceInvoice
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, invoiceInvoiceActions),
        dispatch
    )
)(Invoice);
